module.exports = __webpack_public_path__ + "img/4064007200.3dcc8bf6.jpg";